(function(){ if (window.__v3rv) return; window.__v3rv = true;
/* Goloka V3 home: one-shot reveal-on-scroll for .v3-reveal sections. Content stays visible without JS. */
(function () {
  var root = document.documentElement;
  if (!('IntersectionObserver' in window) || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  var els = document.querySelectorAll('.v3-reveal');
  if (!els.length) return;
  root.classList.add('v3-rv-on');
  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); }
    });
  }, { rootMargin: '0px 0px -8% 0px', threshold: 0.05 });
  els.forEach(function (el) { io.observe(el); });
})();
})();
